"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateReservationStatusRequestToJSON = exports.UpdateReservationStatusRequestFromJSONTyped = exports.UpdateReservationStatusRequestFromJSON = exports.instanceOfUpdateReservationStatusRequest = void 0;
var ReservationStatus_1 = require("./ReservationStatus");
/**
 * Check if a given object implements the UpdateReservationStatusRequest interface.
 */
function instanceOfUpdateReservationStatusRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "version" in value;
    isInstance = isInstance && "status" in value;
    return isInstance;
}
exports.instanceOfUpdateReservationStatusRequest = instanceOfUpdateReservationStatusRequest;
function UpdateReservationStatusRequestFromJSON(json) {
    return UpdateReservationStatusRequestFromJSONTyped(json, false);
}
exports.UpdateReservationStatusRequestFromJSON = UpdateReservationStatusRequestFromJSON;
function UpdateReservationStatusRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'version': json['version'],
        'status': (0, ReservationStatus_1.ReservationStatusFromJSON)(json['status']),
    };
}
exports.UpdateReservationStatusRequestFromJSONTyped = UpdateReservationStatusRequestFromJSONTyped;
function UpdateReservationStatusRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'version': value.version,
        'status': (0, ReservationStatus_1.ReservationStatusToJSON)(value.status),
    };
}
exports.UpdateReservationStatusRequestToJSON = UpdateReservationStatusRequestToJSON;
